<template>
    <v-menu
      offset-y
      :close-on-content-click="false"
      v-model="menu"
    >
      <v-btn flat slot="activator">
        <v-badge overlap :value="count > 0">
          <span slot="badge">{{ count }}</span>
          <v-icon>notifications</v-icon>
        </v-badge>
      </v-btn>

      <v-card>

        <v-list two-line subheader   v-if="hasNotif">
          <v-list-tile
            v-for="(item, idx) in toShow"
            :key="idx">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.message }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-list/>

        <v-card-text v-if="!hasNotif">
          Vous êtes à jour
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="seeHistory">Voir détail</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
</template>

<script>
import promisePoller from 'promise-poller'
export default {
  computed: {
    notifPoll () { return this.$store.getters['ui/notifPoll'] },
    unread () { return this.$store.getters['newnotifications/unfiltered'] },
    toShow () { return this.unread.slice(0, 5) },
    count () { return this.unread.length },
    hasNotif () { return this.count > 0 },
  },
  data: () => ({
    menu: false,
  }),
  methods: {
    seeHistory () {
      this.menu = false
      this.$router.push({ name: 'notifications' })
    },
  },
  mounted () {
    const pollNotifications = () => {
      return new Promise((resolve, reject) => {
        let payload = {
          accessors: {},
          context: {
            params: {
              bust: Date.now(),
            },
          },
          data: {},
        }
        this.$store.dispatch('newnotifications/fetchAll', payload)
        reject(new Error('polling'))
      })
    }
    promisePoller({
      taskFn: pollNotifications,
      interval: this.notifPoll * 60 * 1000, // milliseconds
    })
  },
}
</script>
